import React, { useContext } from 'react';
import propTypes from 'prop-types';
import ClickToBuyInner, { ClickToBuyContext } from '../../components/ClickToBuy/ClickToBuyInner';
import CmsComponent from '../../components/CmsComponent';
import { CLICK_TO_BUY_NAME } from '../../constants/analyticsNames';
import { CLICK_TO_BUY } from '../../constants/cmsResourceTypes';
export const useClickToBuyContext = () => useContext(ClickToBuyContext);
const ClickToBuy = ({ analyticsTags, cqResponsiveClasses, paragraphSystem, position, taxonomyLevel, }) => (React.createElement(ClickToBuyInner, { analyticsTags: analyticsTags, cqResponsiveClasses: cqResponsiveClasses, position: position },
    React.createElement(CmsComponent, { component: paragraphSystem, taxonomyLevel: taxonomyLevel, position: position })));
ClickToBuy.propTypes = {
    analyticsTags: propTypes.shape({}),
    paragraphSystem: propTypes.shape({}),
    cqResponsiveClasses: propTypes.arrayOf(propTypes.string),
    taxonomyLevel: propTypes.string,
    position: propTypes.string.isRequired,
};
ClickToBuy.defaultProps = {
    analyticsTags: undefined,
    cqResponsiveClasses: [],
    paragraphSystem: undefined,
    taxonomyLevel: '',
};
ClickToBuy.displayName = CLICK_TO_BUY_NAME;
ClickToBuy.resourceType = CLICK_TO_BUY;
export default ClickToBuy;
//# sourceMappingURL=index.js.map